import tw from "twin.macro"

export const Card = tw.div`
  shadow-full
  rounded-md
  bg-white
  p-8
  my-8
`
